var map = {
	"./demos/basic/index.ts": 67894,
	"./demos/format/index.ts": 98886,
	"./demos/range/index.ts": 28415,
	"./demos/step/index.ts": 8688,
	"./demos/stepRange/index.ts": 45051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13009;